'use client';
import React, { memo } from 'react';

import { ChevronDown } from '@/app/assets/Icons';
import { Select, SelectItem, SelectProps } from '@nextui-org/react';

interface IProps extends Omit<SelectProps, 'children'> {
	items: any[];
}

const ISelect: React.FC<IProps> = ({ items, ...props }) => {
	return (
		<Select
			className="rounded-full bg-white"
			classNames={{
				selectorIcon: 'right-3 top-1/2 -translate-y-1/2',
				innerWrapper: 'h-auto text-left',
				trigger: 'text-gray text-14',
				value: '!text-gray text-14 group-data-[has-value=true]:!text-black-1',
				listbox: ' p-0',
				listboxWrapper: 'bg-white rounded-xl overflow-hidden',
			}}
			selectorIcon={<ChevronDown className="text-gray" />}
			{...props}
		>
			{items.map((item) => (
				<SelectItem
					classNames={{
						base: 'py-1 border-b px-3 cursor-pointer hover:opacity-80 transition-all hover:bg-mauvelous last:border-0 border-silver',
					}}
					key={item.key}
				>
					{item.label}
				</SelectItem>
			))}
		</Select>
	);
};

export default memo(ISelect);
